import { AddAPhoto, Delete } from "@mui/icons-material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import AttachmentIcon from "@mui/icons-material/Attachment";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import {
  Collapse,
  DialogContentText,
  IconButton,
  TextField,
  Zoom,
  Grid,
} from "@mui/material";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardHeader from "@mui/material/CardHeader";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography/Typography";
import { useEffect, useState } from "react";
import ImageDesigner from "react-image-designer";

import { Document, Page, pdfjs } from "react-pdf";
import ReactPlayer from "react-player";
import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import mime from "mime";
import Lightbox from "yet-another-react-lightbox";
import Download from "yet-another-react-lightbox/plugins/download";
import "yet-another-react-lightbox/styles.css";

import photoPlaceholder from "assets/Svgs/photo-placeholder.svg";
import axios, * as others from "axios";
import {
  allow_docs_mimetypes,
  allow_images_mimetypes,
  allow_videos_mimetypes,
  getFileExtention,
  images_enum,
  videos_enum,
} from "utils/helper";
import { ReactComponent as Magnifier } from "assets/Svgs/magnifier.svg";
import clsx from "clsx";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import i18n from "i18n/i18n";
import UploadAttachmentModal from "./UploadAttachmentModal";
import { useBoundStore } from "store/store";

(async () => {
  pdfjs.GlobalWorkerOptions.workerSrc =
    await `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
})();

const NotificationAttachments = (props: any) => {
  const [showButtn, setShowButton] = useState(true); // to avoid double click
  const [target, setTarget] = useState();
  let useLoc = useLocation();
  let location = props.propLocation ? props.propLocation : useLoc;
  const [numPages, setnumPages] = useState(0);
  const [pageNumber, setpageNumber] = useState(1);
  const [isOpen, setisOpen] = useState(false);
  const [large, setlarge] = useState("");
  const [openDialog, setopenDialog] = useState(false);
  const [nextDisabled, setnextDisabled] = useState(false);
  const [prevDisabled, setprevDisabled] = useState(true);
  const [pdfLink, setpdfLink] = useState("");
  const [documentLoaded, setDocumentLoaded] = useState(false);

  const [localImages, setlocalImages] = useState([]);
  const [noti_image_data, setnoti_image_data] = useState([]);
  const [loader, setloader] = useState(false);

  const [noti_video, setnoti_video] = useState([]);
  const [noti_video_data, setnoti_video_data] = useState([]);
  const [loaderVedio, setloaderVedio] = useState(false);

  const [noti_docs, setnoti_docs] = useState([]);
  const [noti_docs_data, setnoti_docs_data] = useState([]);
  const [loaderDocs, setloaderDocs] = useState(false);

  const [values, setvalues] = useState({});
  const [UploadDialog, setUploadDialog] = useState(false);
  const [fileid, setfileid] = useState();
  const [titleManu, settitleManu] = useState("");
  const [description, setdescription] = useState("");

  const [uploadUrl, setuploadUrl] = useState();
  const [bucketid, setbucketid] = useState();
  const [Newfile, setNewfile] = useState();
  const [fileVersion, setFileVersion] = useState("");
  const [AttachmentNodeid, setAttachmentNodeid] = useState();

  const [moreImages, setMoreImages] = useState([]);
  const [moreVideos, setMoreVideos] = useState([]);
  const [moreDocs, setMoreDocs] = useState([]);

  const [showMoreImages, setShowMoreImages] = useState(false);
  const [showMoreVideos, setShowMoreVideos] = useState(false);
  const [showMoreDocs, setShowMoreDocs] = useState(false);

  const lang: any = useBoundStore((state) => state.lang);

  const handleShowMoreImages = () => {
    setShowMoreImages(!showMoreImages);
  };

  const handleShowMoreVideos = () => {
    setShowMoreVideos(!showMoreVideos);

  }

  const handleNewImage = async (e: any) => {
    setloader(true);
    e.preventDefault();
    var imageSrc = e.target.files[0];

    if (e.target.files.length == 0) {
      setloader(false);
      return false;
    }

    let myFile = e.target.files[0];

    const exstention = getFileExtention(myFile?.type);
    var myImages: any = [];
    myImages = localImages;

    var index =
      Math.floor(Math.random() * 90000) +
      10000 +
      Math.floor(Math.random() * 30000) +
      10000;

    const imgObj = {
      src: URL.createObjectURL(imageSrc),
      index: index,
      uuid: uuidv4(),
    };

    myImages.push(imgObj);
    setlocalImages(myImages);

    myImages = [];

    const image_data: any = localImages;
    var mime_type = "";
    image_data.push({
      nodeid: "nodeid",
      index: imgObj.index,
      fileid: "fileid",
      url: imgObj.src,
      image: imageSrc,
      mime: myFile.type,
      bucketid: "bucketid",
      fileversion: "fileversion",
    });
    setlocalImages(image_data);
    setloader(false);
  };

  const handleClose = () => {
    setisOpen(false);
  };

  const notificationData = props?.notificationData;

  const [preImages, setPreImages] = useState([]);
  const [preVideos, setPreVideos] = useState([]);
  const [preDocs, setPreDocs] = useState([]);

  useEffect(() => {
    var images: any = [];
    var videos: any = [];
    var docs: any = [];

    let workflowAttachments =
      notificationData?.hasworkflow &&
      notificationData?.hasworkflow[0]?.workflow.hasworkflowstep &&
      notificationData?.hasworkflow[0]?.workflow.hasworkflowstep[0]
        ?.workflowstep?.hasattachment;

    if (
      notificationData?.hasattachment &&
      notificationData?.hasattachment.length > 0
    ) {
      notificationData?.hasattachment.map((i: any, k: any) => {
        var mime = i?.attachment?.file?.mimetype
          ? i?.attachment?.file?.mimetype
          : "";
        if (allow_images_mimetypes.includes(mime)) {
          images.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (mime?.includes("video")) {
          videos.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (mime.startsWith('application/') || mime.startsWith('text/')) {
          docs.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            title: Object.keys(i?.attachment?.title).length
              ? i?.attachment?.title[lang]
              : "",
            mimetype: mime,
            uuid: uuidv4(),
          });
        }
      });
      setPreImages(images);
      setPreVideos(videos);
      setPreDocs(docs);
    } 
     
    if (workflowAttachments?.length) {
      // images = [];
      // videos = [];
      // docs = [];

      workflowAttachments.map((i: any, k: any) => {
        var mime = i?.attachment?.file?.mimetype;
        if (allow_images_mimetypes.includes(mime)) {
          images.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (mime?.includes("video")) {
          videos.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (allow_docs_mimetypes.includes(mime.split("/")[0])) {
          docs.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            title: i?.attachment?.title,
            description: i?.attachment?.description,
            mimetype: mime,
            uuid: uuidv4(),
          });
        }
      });
      setPreImages(images);
      setPreVideos(videos);
      setPreDocs(docs);
    }
  }, [notificationData]);

  const [open, setOpen] = useState(false);
  const [lightBoxUrl, setLightBoxUrl] = useState("");

  const onImgClick = (e: any, url: any) => {
    e.preventDefault();
    setOpen(true);
    setLightBoxUrl(url);
  };


  return (
    <>
      

      {open && (
        <Lightbox
          open={open}
          close={() => {
            setOpen(false);
          }}
          slides={[{ src: lightBoxUrl }]}
          plugins={[Download]}
        />
      )}

      {/* Images */}
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={9}>
            {preImages.length ? (
              <div className="generalHeading" style={{ marginTop: "10px" }}>
                {i18n(lang)?.heading_photos}
              </div>
            ) : (
              ""
            )}

            {preImages.length ? (
              <>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {preImages &&
                    preImages.length > 0 &&
                    preImages.slice(0, 3)?.map((i: any, e) => {
                      return (
                        <div
                          style={{
                            display: "flex",
                            margin: "12px 12px 12px 0px",
                            position: "relative",
                          }}
                          key={i.uuid}
                        >
                          <button className="mediaWrapper bxShadow">
                            <img
                              src={i.url}
                              alt={i18n(lang)?.image_here}
                              className="string"
                            />
                            <div className="magnifier">
                              <Magnifier
                                onClick={(e) => {
                                  onImgClick(e, i.url);
                                }}
                              />
                            </div>
                          </button>
                          {props?.edit ? (
                            <IconButton
                            
                            >
                              <Delete />
                            </IconButton>
                          ) : (
                            ""
                          )}
                        </div>
                      );
                    })}
                </div>
              </>
            ) : (
              ""
            )}

            <br />

            {preImages.length > 3 ? (
              <div onClick={handleShowMoreImages} className="showMore">
                <div>
                  {i18n(lang)?.show_n_more.replace(
                    "%s",
                    "" + preImages.slice(3).length
                  )}
                </div>{" "}
                <div className="icon">
                  {" "}
                  {showMoreImages ? (
                    <ExpandLessRoundedIcon />
                  ) : (
                    <ExpandMoreRoundedIcon />
                  )}
                </div>
              </div>
            ) : (
              ""
            )}

            {preImages.length > 3 ? (
              <>
                <Collapse in={showMoreImages} timeout="auto" unmountOnExit>
                  <div
                    className={"uploadedMediaContainer"}
                    style={{ display: "flex", flexWrap: "wrap" }}
                  >
                    {preImages.slice(3)?.map((i: any, e) => {
                      return (
                        <div
                          style={{
                            display: "flex",
                            margin: "12px 12px 12px 0px",
                            position: "relative",
                          }}
                          key={i.uuid}
                        >
                          <button className="mediaWrapper bxShadow">
                            <img
                              src={i.url}
                              alt={i18n(lang)?.image_here}
                              className="string"
                            />
                            <div className="magnifier">
                              <Magnifier
                                onClick={(e) => {
                                  onImgClick(e, i.url);
                                }}
                              />
                            </div>
                          </button>
                          {props.edit ? (
                            <IconButton
                              className={"deleteButton"}
                            >
                              <Delete />
                            </IconButton>
                          ) : (
                            ""
                          )}
                        </div>
                      );
                    })}
                  </div>
                </Collapse>
              </>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      </Grid>

      <br />
      <br />

      {/* Videos */}
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={9} style={{ paddingTop: 0 }}>
            <>
              {preVideos.length ? (
                <div className="generalHeading">
                  {i18n(lang)?.heading_videos}
                </div>
              ) : (
                ""
              )}
            </>
            {preVideos.length ? (
              <>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {preVideos &&
                    preVideos.length > 0 &&
                    preVideos.slice(0, 3)?.map((i: any, e) => {
                      return (
                        <div
                          style={{
                            display: "flex",
                            margin: "12px 12px 12px 0px",
                            position: "relative",
                          }}
                          key={i?.uuid}
                        >
                          <button className="mediaWrapper bxShadow">
                            <video controls width="100%" height="100%">
                              <source src={i?.url} />
                              {i18n(lang)?.browser_doesnot_support}
                            </video>
                          </button>
                        </div>
                      );
                    })}
                </div>
              </>
            ) : (
              ""
            )}

            <br />

            {preVideos.length > 3 ? (
              <div onClick={handleShowMoreVideos} className="showMore">
                <div>
                  {i18n(lang)?.show_n_more.replace(
                    "%s",
                    "" + preVideos.slice(3).length
                  )}
                </div>{" "}
                <div className="icon">
                  {" "}
                  {showMoreVideos ? (
                    <ExpandLessRoundedIcon />
                  ) : (
                    <ExpandMoreRoundedIcon />
                  )}
                </div>
              </div>
            ) : (
              ""
            )}

            {preVideos.length > 3 ? (
              <>
                <Collapse in={showMoreVideos} timeout="auto" unmountOnExit>
                  <div
                    className={"uploadedMediaContainer"}
                    style={{ display: "flex", flexWrap: "wrap" }}
                  >
                    {preVideos.slice(3)?.map((i: any, e) => {
                      return (
                        <div
                          style={{
                            display: "flex",
                            margin: "12px 12px 12px 0px",
                            position: "relative",
                          }}
                          key={i.uuid}
                        >
                          <button className="mediaWrapper bxShadow">
                            <video controls width="100%" height="100%">
                              <source src={i.sources} />
                              {i18n(lang)?.browser_doesnot_support}
                            </video>
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </Collapse>
              </>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      </Grid>

      {/* Docs */}
       <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={9}>
            <>
              <div className="generalHeading" style={{ marginTop: "10px" }}>
                {i18n(lang)?.heading_docs}
              </div>
            </>
            {preDocs.length ? (
              <>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {preDocs &&
                    preDocs.length > 0 &&
                    preDocs?.map((i: any, e) => {
                      let mimeType = mime?.getExtension(i?.mimetype);
                      return (
                        <div
                          style={{
                            display: "flex",
                            margin: "12px 12px 12px 0px",
                          }}
                          key={i?.uuid}
                        >
                          <Card
                            className={"cardButtonLarge"}
                            variant="outlined"
                            onClick={() => {

                              window.open(i?.url, "PDF Viewer");
                            }}
                          >
                            <CardActionArea
                              sx={{
                                border: "1px solid rgba(0, 0, 0, 0.12)",
                              }}
                            >
                              <CardHeader
                                avatar={
                                  <Icon color="primary" className={"cardIcon"}>
                                    <AttachmentIcon />
                                  </Icon>
                                }
                                style={{ height: "70px" }}
                                subheader={
                                  <div className="attachmentWrapper">
                                    <div className="content">
                                      <div className="attachmentHeader">
                                        {i?.title
                                          ? i?.title
                                          : i18n(lang)?.no_workflow_title}{" "}
                                        <span
                                          style={{ marginLeft: "2px" }}
                                          className="mimeType"
                                        >
                                          {mimeType ? mimeType : "no_type"}{" "}
                                        </span>
                                      </div>
                                      <div
                                        className="attachmentSubHeader"
                                        style={{ width: "max-content" }}
                                      >
                                        {i?.description ? i?.description : ""}{" "}
                                      </div>
                                    </div>
                                  </div>
                                }
                              />
                            </CardActionArea>
                          </Card>
                        </div>
                      );
                    })}
                </div>
              </>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      </Grid> 

      <UploadAttachmentModal
        hasTitle
        hasDescription
        open={UploadDialog}
        customFileChange={props.customFileChange}
        onClose={handleClose}
        file={Newfile}
        hasCategory={false}
        setFile={setNewfile}
        description={description}
        setDescription={setdescription}
        title={titleManu}
        setTitle={settitleManu}
        setTarget={setTarget}
        target={target}
        showButtn={showButtn}
        setShowButton={setShowButton}
      />
    </>
  );
};

export default NotificationAttachments;
